module.exports = __webpack_public_path__ + "img/1566097129.81b65e39.jpg";